import { lazy } from 'react';

import type { RouteConfig } from '../../types';

// Lazy load layouts
const DashboardLayout = lazy(() => import('@/layouts/DashboardLayout'));
const LicensesLayout = lazy(() => import('@/pages/licenses/layout'));

// Lazy load license pages
const LicensesPage = lazy(() => import('@/pages/licenses'));
const LicensesHistoryPage = lazy(() => import('@/pages/licenses/history'));

/**
 * License Registry routes (Business → Licenses).
 * Grid + registry-wide History; add/edit live in a modal on the grid page.
 */
export const licenseRoutes: RouteConfig = {
  path: '/licenses',
  layout: DashboardLayout,
  children: [
    {
      path: '',
      layout: LicensesLayout,
      children: [
        {
          path: '',
          element: LicensesPage,
        },
        {
          path: '/history',
          element: LicensesHistoryPage,
        },
      ],
    },
  ],
};
